goog.provide("shadow.js.shim.module$ol$Collection");
goog.provide("module$shadow_js_shim_module$ol$Collection");
shadow.js.shim.module$ol$Collection = shadow.js.nativeProvides["ol/Collection"] = shadow$bridge("ol/Collection");
module$shadow_js_shim_module$ol$Collection.default = shadow.js.shim.module$ol$Collection;
